import { ImageContext, imageContextValue } from "../../context/imageContext";

export function ImageContextProvider(props: { children: React.ReactNode }) {
  return <ImageContext.Provider value={imageContextValue}>{props.children}</ImageContext.Provider>;
}
